import { api } from '@/lib/customFetch'
import type { DashboardSummary, DocumentSummary, PagedList } from '@/lib/types/ged'

export const meKeys = {
  dashboard: () => ['me', 'dashboard'] as const,
  recents: (page: number, pageSize: number) => ['me', 'recents', page, pageSize] as const,
}

export async function getDashboard(): Promise<DashboardSummary> {
  return api.get<DashboardSummary>('/me/dashboard')
}

export async function getRecents(page = 1, pageSize = 20): Promise<PagedList<DocumentSummary>> {
  return api.get<PagedList<DocumentSummary>>(`/me/recents?page=${page}&pageSize=${pageSize}`)
}
